<template>
  <div>
    <app-navbar/>
    <v-content>
        <v-container fluid>
          Page Mails
        </v-container>
    </v-content>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Navbar from '@/components/comps/Navbar.vue'
import Footer from '@/components/comps/Footer.vue'
import router from "@/plugins/router";
import config from "../../config"
export default {
  name: "Home",
  mounted() {
    this.checkLoggedIn();
  },
  components: {
    'app-navbar' : Navbar,
    'app-footer' : Footer,
  },
  methods: {
     checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        router.push("/auth");
      }else{
         axios({
          method : 'get',
          url : config.api.baseurl+'/api/user',
          headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        })
        .then(response => {
          this.$session.set('user',response.data);
          router.push('/');
        }).catch(e=> {
          router.push("/auth");
        });
      }
    }
  }
};
</script>
